import { render, staticRenderFns } from "./leaveInfo.vue?vue&type=template&id=6e726524&"
import script from "./leaveInfo.vue?vue&type=script&lang=js&"
export * from "./leaveInfo.vue?vue&type=script&lang=js&"
import style0 from "./leaveInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports